import { createFileRoute } from '@tanstack/react-router'

import { PlatformPendingSubscriptionHistoryPage } from '../../../../../components/pages/backoffice/platform/platform-pending-subscription-history-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/subscriptions/$subscriptionId/history')({
  component: () => (
    <PermissionChecker requiredPermissions={['debugHistory.read']}>
      <PlatformPendingSubscriptionHistoryPage />
    </PermissionChecker>
  ),
})
